import { TransactionWrapper } from './transactionWrapper';

export class TransactionWrapperData { 
  callingServiceName?: string;
  transactionWrapper?: TransactionWrapper;
}
